import React from "react";

import { PaymentSuccess } from "components/Payment/PaymentSuccessPage";

const PaymentSuccessPage = () => {
  return <PaymentSuccess />;
};
export default PaymentSuccessPage;
